import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../config/design/TableIcons";
import {Link, withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import {TableCount, TablePage} from "../../../../config/Permissions";
import Button from "@material-ui/core/Button/Button";
import AddBox from "@material-ui/icons/AddBox";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import AppCardLoaderTable from "../../../components/Skeletons/AppCardLoaderTable";
import IconButton from "@material-ui/core/IconButton/IconButton";
import withWidth from "@material-ui/core/withWidth/withWidth";
import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import {currencySymbol, truncate} from "../../../../config/values";
import OpenInNewRoundedIcon from "@material-ui/icons/OpenInNewRounded";
import Alert from "@material-ui/lab/Alert/Alert";
class Festivals extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            {
                field: 'thumbnail',
                editable: 'never',
                filtering: false,
                sorting:false,
                title: Translate.thumbnail,
                render: rowData => <img alt="avatar" src={rowData.thumbnail} className={this.classes.FMThumbnail}/>
            },
            { title: Translate.festival_name,
                field: 'name',
                filterPlaceholder: Translate.search,
                render: rowData =>
                    <>
                        <Button
                            size="small"
                            startIcon={<OpenInNewRoundedIcon color="primary"/>}
                            component="a"
                            href={`${defaultVariabls.website}/festival/${rowData.slug}`}
                            target="_blank"
                        >
                            {truncate(rowData.name,17)}
                        </Button>
                    </>
            },
            { title: Translate.discount_value,
                field: 'value',
                filterPlaceholder: Translate.search,
                render: rowData => rowData.value+" "+ (rowData.type === "percent" ? "%" : currencySymbol)
            },
            { title: Translate.festival_starts_at, field: 'starts_at',filterPlaceholder: Translate.search},
            { title: Translate.festival_ends_at, field: 'ends_at',filterPlaceholder: Translate.search},
            { title: Translate.activityStatus,
                editable: 'never',
                field: 'active',
                filterPlaceholder: Translate.choose,
                lookup: {
                    1 :
                        <Typography style={{color: "#38bf84"}}>{Translate.active}</Typography>
                    , 0:
                        <Typography color="textSecondary">{Translate.inactive}</Typography>
                },
            },
            { title: Translate.activity,
                editable: 'never',
                sorting:false,
                field: 'activity',
                render: rowData =>
                    <Button
                        variant="outlined"
                        color="primary"
                        component={Link}
                        to={`/edit/festival/${rowData.id}`}
                        endIcon={<ChevronLeftRoundedIcon/>}
                        size={"small"}
                        style={{marginBottom:5,marginRight:5}}
                    >
                        {Translate.edit}
                    </Button>
            },
        ],
        data: [],
        loading:false,
        ChangeLoader:false
    };
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    onDelete(id,hasNotif = true) {
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/festival/delete`, data, config)
            .then(response => {
                if(hasNotif){
                    this.props.enqueueSnackbar(Translate.deleteData, {
                        variant: 'success',
                    });
                }
                return true
            })

            .catch(error => {
                this.loadData();
                this.props.enqueueSnackbar(Translate.deleteDataFailed, {
                    variant: 'error',
                });
                return false
            });
    }
    render(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl">
                            <MaterialTable
                                parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                                tableRef={this.tableRef}
                                icons={tableIcons}
                                title={
                                    <Link to='/create/festival'>
                                        {
                                        this.props.width !== "xs" ?
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                startIcon={<AddBox/>}
                                            >
                                                {Translate.makeFestival}
                                            </Button>
                                            :
                                            <IconButton color="primary">
                                                <AddBox/>
                                            </IconButton>
                                        }
                                    </Link>
                                }

                                localization={DataTableLocalization}
                                columns={this.state.columns}
                                data={query =>
                                    new Promise((resolve, reject) => {
                                        axios.get(`${defaultVariabls.url}/festivals/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, config)
                                            .then(response => {
                                                let data = [];
                                                // eslint-disable-next-line
                                                response.data.data.map((row) => {
                                                    data.push({
                                                        thumbnail: `${defaultVariabls.uploads}/FileManager/${row.thumbnail.name}_small.${row.thumbnail.extension}`,
                                                        name: row.name,
                                                        slug: row.slug,
                                                        type: row.type,
                                                        value: row.value,
                                                        id: row.id,
                                                        active: row.active,
                                                        ends_at:!!row.ends_at ? `${moment(row.ends_at).locale('fa').format('jYYYY/jM/jD')}` : null,
                                                        starts_at:!!row.ends_at ? `${moment(row.starts_at).locale('fa').format('jYYYY/jM/jD')}` : null,
                                                    })
                                                });
                                                resolve({
                                                    data: data,
                                                    page: response.data.current_page - 1,
                                                    totalCount: response.data.total,
                                                })
                                            }).catch(error => {
                                            console.log(error.response)
                                        })
                                    })
                                }
                                options={{
                                    pageSize: TablePage,
                                    pageSizeOptions: TableCount,
                                    defaultExpanded:true,
                                }}
                                editable={{
                                    onRowDelete: oldData =>
                                        new Promise(resolve => {
                                            setTimeout(() => {
                                                resolve();
                                                this.onDelete(oldData.id);
                                                this.setState(prevState => {
                                                    const data = [...prevState.data];
                                                    data.splice(data.indexOf(oldData), 1);
                                                    return { ...prevState, data };
                                                });
                                            }, 600);
                                        }),
                                }}

                            />
                        </Container>
                }
            </>

        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Festivals)))));